import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const fragranceKeyNotesFragment = `
    on ${QueryType.product} {
        fragrance_key_notes
    }
`;

export const productFragranceKeyNotesFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.product]: fragranceKeyNotesFragment
    };
};
